import { useEffect, useRef } from 'react';

/**
 * @var settings JSON
 * enterToSubmit: boolean - if true, blurs the textarea on enter key.
 * extraHeight: integer - extra amount to add to the calculation.
 */
export const useAutosizeTextarea = (settings) => {
  const textareaRef = useRef(null);
  // Adding extra height setting if the text needs to be underlined. Otherwise
  // the underline is obscured by the explicit height applied to element.
  const { enterToSubmit, extraHeight = 0 } = settings || {};

  const setHeight = (textarea) => {
    textarea.style.height = 0;
    const { scrollHeight } = textarea;
    textarea.style.height = `${scrollHeight + extraHeight}px`;
  };

  const submitOnKeypress = (e, textarea) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      textarea.blur();
    }
  };

  useEffect(() => {
    const handleInput = () => {
      if (textarea) {
        setHeight(textarea);
      }
    };
    const handleKeypress = (e) => {
      if (textarea) {
        submitOnKeypress(e, textarea);
      }
    };
    const textarea = textareaRef.current;
    if (textarea) {
      setHeight(textarea);
      textarea.addEventListener('input', handleInput);
      if (enterToSubmit) {
        textarea.addEventListener('keydown', handleKeypress);
      }
    }

    return () => {
      if (textarea) {
        textarea.removeEventListener('input', handleInput);
        if (enterToSubmit) {
          textarea.removeEventListener('keydown', handleKeypress);
        }
      }
    };
  }, []);

  return { textareaRef };
};
